
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { MenuContent } from "./header/MenuContent";
import { WalletSection } from "./header/WalletSection";
import { CreateCoinButton } from "./header/CreateCoinButton";

const Header = () => {
  const navigate = useNavigate();

  return (
    <header className="border-b border-border/40 backdrop-blur-xl bg-background/30 fixed top-0 w-full z-50">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center">
            <span 
              onClick={() => navigate('/')} 
              className="mr-2 cursor-pointer hover:opacity-80 transition-opacity"
            >
              🦾
            </span>
            {/* Mobile Menu */}
            <div className="block md:hidden">
              <Sheet>
                <SheetTrigger asChild>
                  <Button variant="ghost" size="icon">
                    <Menu className="h-6 w-6 text-muted-foreground" />
                  </Button>
                </SheetTrigger>
                <SheetContent side="left" className="w-[300px] sm:w-[400px]">
                  <nav className="flex flex-col gap-4">
                    <MenuContent />
                  </nav>
                </SheetContent>
              </Sheet>
            </div>
            {/* Desktop Menu */}
            <div className="hidden md:block">
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" size="icon">
                    <Menu className="h-6 w-6 text-muted-foreground" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start" className="w-48 bg-transparent border-none p-0">
                  <MenuContent />
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
          <span 
            onClick={() => navigate('/')} 
            className="text-xl font-semibold bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent cursor-pointer hover:opacity-80 transition-opacity"
          >
            Matic Moon
          </span>
        </div>
        <div className="flex items-center space-x-4">
          <WalletSection />
          <CreateCoinButton />
        </div>
      </div>
    </header>
  );
};

export default Header;
